function pascalToSnakeCase(string){
  return string.replace(/\.?([A-Z]+)/g, (x, y) => `_${y.toLowerCase()}`).replace(/^_/, '')
}

export default pascalToSnakeCase
